jQuery(function($){
  console.log('work');
  $(document).on('click','#theme-ajax-cart .add-note a', function(){
    $('.note_section').addClass('afterbefore');
    $('.note_section_btton').removeClass('hide');
    $('.ajax-cart__list, .ajax-cart__subtotal, .ajax-cart__taxes-shipping, .ajax-cart__button-wrapper').addClass('hide'); 
  });

  $(document).on('click','#theme-ajax-cart .note_section', function(){
    $(this).removeClass('afterbefore');
  });


  $(document).on('click','#theme-ajax-cart .c_btn', function(){

    $('.ajax-cart__note').val('');
    $('.note_section_btton, .edit-remove').addClass('hide');
    $('.ajax-cart__list, .ajax-cart__subtotal, .ajax-cart__taxes-shipping, .ajax-cart__button-wrapper, .add-note').removeClass('hide');   
  });


  $(document).on('click','#theme-ajax-cart .s_btn', function(){
    $('.note_section_btton,.add-note').addClass('hide');

    $('.ajax-cart__list, .ajax-cart__subtotal, .ajax-cart__taxes-shipping, .ajax-cart__button-wrapper, .edit-remove').removeClass('hide');   
  });


  $(document).on('click','.e_btn', function(){
     $('.note_section_btton').removeClass('hide');
    $('.ajax-cart__list, .ajax-cart__subtotal, .ajax-cart__taxes-shipping, .ajax-cart__button-wrapper').addClass('hide'); 
  });

  
  $(document).on('click','.r_btn', function(){
    console.log("click work");
     $('.ajax-cart__note').val('');
    $('.edit-remove').addClass('hide');
     $('.add-note').removeClass('hide');
  });

});

// Location
jQuery(function($){

  var geocountry = '';
  var geourl = document.location.host;
  // $.get("https://ipinfo.io", function(response) {
  //     console.log(response);
  //     console.log(response.city);
  //     geocountry = response.country;
  // }, "json");

  // $.ajax({
  //   url: "https://geolocation-db.com/jsonp",
  //   jsonpCallback: "callback",
  //   dataType: "jsonp",
  //   success: function (location) {
  //     console.log(location);
  //     geocountry = location.country_code;
  //   }
  // });
$.getJSON('https://api.db-ip.com/v2/free/self', function(data) {
  console.log(data);
  geocountry = data.countryCode;
});
  

  $('.location-text').on('click',function(){
      console.log(document.location.origin);
      localStorage.setItem("country", "noCountry");
      localStorage.setItem("countryUrl", document.location.origin);
      history.replaceState('', '', document.location.origin);
        document.querySelector('.header__logo').setAttribute("href", document.location.origin);
      $('.location-drawer, .location_overlay').addClass('is-visible');
    });
  

  $(document).on('click','.location-close-icon, .location_overlay', function(){
    localStorage.setItem("country", "fromCountry");
    $('.location-drawer, .location_overlay').removeClass('is-visible');
  }); 
  console.log(localStorage);
  var country = localStorage.getItem('country');
  var countryURL = localStorage.getItem('countryUrl');
 
  setTimeout(function() {
     console.log("The URL contains ?country"+country);
    if(country == "fromCountry"){
      console.log("if fromCountry = "+countryURL);
      $('.location-drawer, .location_overlay').removeClass('is-visible');
      document.querySelector('.header__logo').setAttribute("href", countryURL);
    }else{
      console.log("else fromCountry");
      if(geourl == 'writetomeshop.com' && geocountry == 'US'){
        console.log("else if fromCountry");
        console.log('match domain and url')
        // document.querySelector('.header__logo').setAttribute("href", countryURL);
      }else{
        console.log("else else fromCountry");
        $('.location-drawer, .location_overlay').addClass('is-visible');
        console.log('geourl = '+geourl);
        console.log('country = '+geocountry);
      }
    }
  },7000);  
});


// collection mobile filter 
jQuery(function($){
  $("ul").on("click", ".init", function() {
    $(this).closest("ul").children('li:not(.init)').toggle();
  });
});


//blog page
jQuery(function($){
  /*------------Smooth scroll--------------------*/
  $('.scroll-trigger a[href^="#"]').on('click', function (e) {
    e.preventDefault();

    var target = this.hash;
    var $target = $(target);

    $('html, body').animate({
      'scrollTop': $target.offset().top
    }, 1000, 'swing');
  });
  

});




// product slider
jQuery(function($){
  $('.mobile_slider_true').flickity({
    // options
    cellAlign: 'left',
    contain: true,
    watchCSS: true,
    adaptiveHeight: true,
    // disable previous & next buttons and dots
    prevNextButtons: false,
    pageDots: true
  });
  
});

// icon bar
var elem = document.querySelector('.icon-bars');
var flkty = new Flickity( elem, {
  wrapAround: true,
  pageDots: false,
  initialIndex: 1,
  fade: true,
  watchCSS: true,
  prevNextButtons: false,
  accessibility: true, //true by default
  autoPlay: true // advance cells every 3 seconds
});